import fs from "node:fs";
import { z, ZodType } from "zod/v4";

/**
 * DateTime type compatible with OCPI
 */
export const OcpiDateTime = z.iso.datetime({ local: true }).max(25);

const OCPI_SCHEMA_DIR = ".ocpi-schema";
export const saveJsonSchema = (
  dirName: string,
  schemaName: string,
  schema: ZodType,
) => {
  if (!fs.existsSync(`${OCPI_SCHEMA_DIR}/${dirName}`)) {
    fs.mkdirSync(`${OCPI_SCHEMA_DIR}/${dirName}`, { recursive: true });
  }
  fs.writeFileSync(
    `${OCPI_SCHEMA_DIR}/${dirName}/${schemaName}.json`,
    JSON.stringify(z.toJSONSchema(schema), null, 2),
  );
};
